import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, disabled = false, mini = false }) => ({
  color: 'black',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.fontSize.normal,
  paddingLeft: theme.margin.medium,
  paddingRight: theme.margin.medium,
  gap: theme.margin.fine,
  height: '3.5rem',
  borderRadius: '5px',
  backgroundColor: theme.color.buttonColor,
  opacity: theme.opacity.hovered,
  transition: `background-color ${theme.transition.default}`,
  ':hover': {
    backgroundColor: theme.color.buttonColorHover,
  },
  extend: [
    {
      condition: mini,
      style: {
        paddingLeft: theme.margin.fine,
        paddingRight: theme.margin.fine,
        height: '2.5rem',
      },
    },
    {
      condition: disabled,
      style: {
        cursor: 'default',
        opacity: theme.opacity.enabled,
        ':hover': {
          backgroundColor: theme.color.buttonColor,
        },
      },
    },
  ],
});

const ControlContainer = ({ mini, disabled, onClick, children }) => {
  const { css } = useFela({
    mini,
    disabled,
  });

  return (
    <div className={css(rules)} onClick={onClick}>
      {children}
    </div>
  );
};

ControlContainer.propTypes = {
  mini: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default React.memo(ControlContainer);
